import React, { Component } from 'react'
import { CardHeader, Row, Button, Col, Table, CardBody } from 'reactstrap'
import gql from 'graphql-tag'
import _ from 'lodash'
import { graphql, compose } from 'react-apollo'
import InspectionCategoryForm from './InspectionCategoryForm'
import ConfirmModal from '../Alerts/ConfirmModal'
import { UnmountClosed } from 'react-collapse'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { updateBreadcrumbs } from '../../actions/breadcrumbs'

class InspectionCategoryList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      categoryList: [],
      inspection_categories: [],
      InspectionCategoryIdRemove: null,
      formIsOpened: false,
      dataToEdit: null
    }

    this.runRemoveInspectionCategory = this.runRemoveInspectionCategory.bind(this)
    this.closeConfirmModal = this.closeConfirmModal.bind(this)
    this.handleFormToggle = this.handleFormToggle.bind(this)
    this.afterSubmitCategory = this.afterSubmitCategory.bind(this)
  }

  static propTypes = {
    data: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    destroyInspectionCategoryMutation: PropTypes.func.isRequired,
    updateBreadcrumbs: PropTypes.func.isRequired
  }

  componentWillReceiveProps(nextProps) {
    if (this.props === nextProps) {
      return
    }

    if (nextProps.data.loading === false && nextProps.data.element) {
      this.setState({
        categoryList: nextProps.data.element.inspection_categories,
        formIsOpened: false,
      })

      // BREADCRUMBS
      let project = nextProps.data.element
      this.props.updateBreadcrumbs([{ id: project.id, name: project.name }])
    }
  }

  componentWillUnmount() {
    this.props.updateBreadcrumbs([])
  }

  runRemoveInspectionCategory() {
    this.removeInspectionCategory(this.state.InspectionCategoryIdRemove)
  }

  closeConfirmModal() {
    this.setState({ InspectionCategoryIdRemove: null })
  }

  removeInspectionCategory(id) {
    this.props.destroyInspectionCategoryMutation({
      variables: { id: id }
    }).then(() => {
      let newInspectionCategoryList = this.state.categoryList.filter(function (item) {
        return (item.id !== id)
      })

      this.setState({ categoryList: newInspectionCategoryList, InspectionCategoryIdRemove: null })
    })
  }

  handleFormToggle() {
    this.setState({ formIsOpened: !this.state.formIsOpened })
  }

  afterSubmitCategory() {
    this.setState({ dataToEdit: null, formIsOpened: false })
    this.props.data.refetch()
  }

  getUsedInspectionTypes() {
    const usedTypeIds = new Set()
    this.state.categoryList.forEach(category => {
      category.inspections.forEach(inspection => {
        usedTypeIds.add(Number(inspection.type_id))
      })
    })
    return this.props.data.inspection_category_types
      .filter(type => usedTypeIds.has(Number(type.id)))
  }

  renderList() {
    return [...this.state.categoryList]
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(inspection_category => {
        return (
          <tr key={inspection_category.id}>
            <td>
              {inspection_category.name}
            </td>
            {this.getUsedInspectionTypes().map(inspCatType => {
              let inspByTypeId = _.find(inspection_category.inspections, (o) => o.type_id === Number(inspCatType.id))
              return (
                <td key={inspCatType.id}>
                  {inspByTypeId ? `${inspByTypeId.range}% / ${inspByTypeId.double_length ? 'DL' : 'SL'}` : ''}
                </td>)
            }
            )
            }
            <td>
              {inspection_category.hold_time}
            </td>
            <td>
              <Button color="danger" className="float-right" title="Remove" onClick={(e) => {
                e.stopPropagation()
                this.setState({
                  InspectionCategoryIdRemove: inspection_category.id
                })
              }}>
                <i className="fa fa-trash-o" />
              </Button>

              <Button color="warning" className="float-right" title="Edit" onClick={(e) => {
                e.stopPropagation()
                this.setState({
                  dataToEdit: inspection_category,
                  formIsOpened: true,
                })
              }}>
                <i className="fa fa-edit" />
              </Button>

            </td>
          </tr>
        )
      })
  }

  render() {
    if (this.props.data.loading) {
      return (<div>Loading</div>)
    }

    if (this.props.data.error) {
      if (this.props.data.error.networkError && this.props.data.error.networkError.statusCode === 404) {
        return (<div>Not Found</div>)
      } else {
        return (<div>An unexpected error occurred{JSON.stringify(this.props.data.error)}</div>)
      }
    }

    return (
      <div>
        <UnmountClosed isOpened={this.state.formIsOpened}>
          <InspectionCategoryForm
            projectId={Number(this.props.match.params.id)}
            formToggleFunction={this.handleFormToggle}
            submitFunction={this.state.submitFunction}
            editData={this.state.dataToEdit}
            afterSubmit={this.afterSubmitCategory}
            inspectionCategoryTypes={this.props.data.inspection_category_types}
            companiesData={this.props.data.companies.list}
          />
        </UnmountClosed>
        <ConfirmModal
          isOpened={!!this.state.InspectionCategoryIdRemove}
          onCancel={this.closeConfirmModal}
          onConfirm={this.runRemoveInspectionCategory}
          headerText='Remove'
          bodyText='Are you sure you want to delete this Inspection Category?'
          confirmBtnText='Remove'
        />
        <CardHeader>
          <b>Inspection category</b>

          {!this.state.formIsOpened &&
            <Button color="primary"
              className="float-right btn-add-project"
              onClick={() => {
                this.setState({
                  dataToEdit: null,
                  formIsOpened: true,
                })
              }}
            >
              <i className="fa fa-plus" /> New category
            </Button>}
        </CardHeader>
        <CardBody>
          <Row>
            <Col md="12">
              <Table responsive className="table-project">
                <thead>
                  <tr>
                    <th>Category</th>
                    {this.getUsedInspectionTypes().map(inspCatType => <th key={inspCatType.id}>{inspCatType.name}</th>)}
                    <th>Hold time (hours)</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderList()}
                </tbody>
              </Table>
            </Col>
          </Row>
        </CardBody>
      </div>
    )
  }
}

const destroyInspectionCategoryMutation = gql`
  mutation destroyInspectionCategory($id: ID!) {
    destroyInspectionCategories(id: $id) {
      response
    }
  }
`

export const InspectionCategoriesFetchQuery = gql`
  query InspectionCategoriesFetchQuery($project_id: ID!, $roles: [String]) {
    element(id: $project_id) {
      id
      name
      inspection_categories {
        id
        name
        hold_time
        inspections {
          type_id
          range
          company_id
          double_length
          sort_order
        }
      }
    }
    inspection_category_types {
      id
      name
    }
    companies(roles: $roles) {
      list {
        id
        name
      }
    }
  }
`

const InspectionCategoryWithData = compose(
  graphql(InspectionCategoriesFetchQuery, {
    options: (props) => ({
      fetchPolicy: 'network-only',
      variables: { project_id: props.match.params.id, roles: ['INSPECTIONS'] }
    }),
  }),
  graphql(destroyInspectionCategoryMutation, { name: 'destroyInspectionCategoryMutation' })
)(InspectionCategoryList)

export default connect(null, { updateBreadcrumbs })(InspectionCategoryWithData)



// WEBPACK FOOTER //
// ./src/components/InspectionCategory/InspectionCategoryList.js